module.exports = __webpack_public_path__ + "img/5_49.033a1a64.png";